module.exports = __webpack_public_path__ + "static/img/up-f.60e4d03e.png";